import { ValidationLevel, ValidationProps } from 'ui/common/validation/types';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { ValidationData } from 'app/area/codetable/item/validation/validate';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { createSafetyLimitId } from 'app/area/codetable/item/codetable-item-helpers';

const requiredError = (message: string): ValidationProps => ({
  level: ValidationLevel.error,
  messages: [{ level: ValidationLevel.error, message }]
});

export const validateGasType = ({ codeItem, translation }: ValidationData): { [key: string]: ValidationProps } => {
  if (!codeItem.safetyLimit?.length) {
    return {};
  }

  return Object.assign({}, ...codeItem.safetyLimit.map(item => {
    const appId = item.application?.value;
    const minMaxEmpty = !isDefinedIncludingZero(item.minValue) && !isDefinedIncludingZero(item.maxValue);
    const minMaxError = requiredError(translation.min_max_value_error_message);
    const deviationPercentError = requiredError(translation.must_be_filled_out);

    return {
      [createSafetyLimitId(ScreenPicker.minValue, appId)]: minMaxEmpty ? minMaxError : undefined,
      [createSafetyLimitId(ScreenPicker.maxValue, appId)]: minMaxEmpty ? minMaxError : undefined,
      [createSafetyLimitId(ScreenField.warningDeviationPercent, appId)]:
        !isDefinedIncludingZero(item.warningDeviationPercent) ? deviationPercentError : undefined
    };
  }));
};
